import { render } from "./DeactivateAccountView.vue?vue&type=template&id=01b6374a"
import script from "./DeactivateAccountView.vue?vue&type=script&lang=js"
export * from "./DeactivateAccountView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__